import "core-js/modules/es.array.concat";
var colors = {
  default: 'gray',
  action: 'inherit',
  module: '#03A9F4',
  resource: '#4CAF50'
};
/**
 * 生成样式
 * @param {keyof colors} type 颜色类型
 * @param {string} weight 字重
 */

function style(type) {
  var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'bold';
  return "color: ".concat(colors[type], "; font-weight: ").concat(weight);
}
/**
 * 日志输出
 * @param {boolean} silent
 */


export default function createLogger() {
  var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  /**
   * @param {string} action
   * @param {VftReport.ReportParams} params
   */
  function logger(action) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (silent) {
      return;
    }

    var type = params ? params.f_type : -1;
    console.groupCollapsed("%c[reporter] %c(".concat(type === 0 ? 'pv' : action).concat(type === 1 ? '.module' : '', ")"), style('default', 'lighter'), style('action'));

    if (params) {
      if (params.f_module) {
        console.log('%c f_module:', style('module'), params.f_module);
      }

      if (params.f_resource) {
        console.log('%c f_reource:', style('resource'), params.f_resource);
      }

      console.table(params);
    }

    console.groupEnd();
  }

  return logger;
}